/*
 * Copyright (c) Dito Technologies LLC
 */

import React from "react";
import {QueryRenderer} from "react-relay";
import environment from "constants/environment";
import ErrorSection from "ui/common/ErrorSection";
import LoadingSection from "ui/common/LoadingSection";
import query from "ui/feature/piece-play/common/piece-renderer/PieceRendererViewOriginalImageQuery";
import {
    PieceRendererViewOriginalImageQuery
} from "ui/feature/piece-play/common/__generated__/PieceRendererViewOriginalImageQuery.graphql";
import PieceRendererViewOriginalImageData from "ui/feature/piece-play/common/piece-renderer/PieceRendererViewOriginalImageData";
import styles from "ui/feature/piece-play/common/piece-renderer/PieceRendererViewOriginalImage.module.scss"

interface Props {
    jobId: string | null;
}

const PieceRendererViewOriginalImage: React.FC<Props> = ({jobId}) => {

    if (!jobId) {
        return null;
    }

    return (
        <div className={styles.container}>
            <QueryRenderer<PieceRendererViewOriginalImageQuery>
                environment={environment}
                query={query}
                variables={{job_id: jobId}}
                render={({error, props, retry}) => {
                    if (error) {
                        return <ErrorSection/>;
                    } else if (props) {
                        if (props.music_viewer.note_original_image_extractor.image_download_url) {
                            return <PieceRendererViewOriginalImageData
                                image_url={props.music_viewer.note_original_image_extractor.image_download_url}/>;
                        } else {
                            setTimeout(() => {
                                if (retry) {
                                    console.log("retrying!");
                                    retry();
                                }
                            }, 1000);
                            return <LoadingSection/>;
                        }
                    } else {
                        return <LoadingSection/>;
                    }
                }}/>
        </div>
    );
}

export default PieceRendererViewOriginalImage;
